// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___2dBtJ","editButtonArea":"index-module__editButtonArea___3ciVq","button":"index-module__button___3xbhN"};